module.exports = __webpack_public_path__ + "static/media/soundoff.f130c39f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soundoff.svg
// module id = 614
// module chunks = 0